import React, { Component } from 'react';

import Analytics from 'APP_ROOT/services/analytics';
import HistoryUtil from '../../common/historyUtil';
import CognitoUtil from '../../aws/cognito/cognitoUtil';
import Events from '../../common/events';
import PasswordPolicyChecklist from '../../common/passwordPolicyChecklist';
import { strings } from '../../../localization';

export default class CreateAccountPage extends Component {

    constructor(props) {

        super(props);

        this.state = {
            validateEmailMessage: null,
            validatePasswordMessage: null,
            validateConfirmPasswordMessage: null,
            validationFailed: false,
            errorMessage: null, 
            password: "",
            isPasswordValid: false
        }
    }

    componentWillMount() {
        const params = new URLSearchParams(this.props.location.search);
        const userType = params.get('userType');
        if (userType === 'prime') {
            HistoryUtil.push(`/prime/create-account${this.props.location.search}`);
            return;
        }
        Analytics.pageView();
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
    }

    componentDidMount() {
        this.setInputDefaults();
    }

    componentDidUpdate(prevProps) {
        if(this.props.pendingInvite && !prevProps.pendingInvite){
            this.setInputDefaults();
        }
    }

    setInputDefaults() {
        if(this.props.pendingInvite){
            if(this.emailInput){            
                this.emailInput.setAttribute('disabled', true);
                this.emailInput.value = this.props.pendingInvite.inviteEmail;
            }
        }
    }

    onPasswordChange = (e) => {
        this.setState({
            password: e.target.value
        });
    }

    onSubmit = (e) => {

        e.preventDefault();
        if (this.validateForm()) {
            document.user = {
                email: this.emailInput.value,
                password: this.passwordInput.value,
                driverName: this.driverNameInput.value
            }
            document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: strings.formatString(strings.app_loading) } }));
            CognitoUtil.createUser(this.emailInput.value, this.passwordInput.value, this.driverNameInput.value, this.props.pendingInvite, this.createUserSuccess, this.createUserFail);
        }
    }

    createUserFail = (e) => {

        console.error(e);

        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));

        this.setState({
            errorMessage: strings.formatString(strings.error_create_kloud_user)
        })
    }

    createUserSuccess = (user) => {
        const driverName = this.driverNameInput.value;
        const email = user.getUsername();

        this.props.setPendingInvite({
            ...this.props.pendingInvite,
            driverName: driverName
        });
        //go to verify page
        HistoryUtil.push(`/verify-account?token=${this.props.pendingInvite.token}#${email}`);
    }

    validateForm() {

        var driverNameV = this.driverNameInput.value.length > 0;
        var emailV = this.emailInput.value.length > 0;
        var passwordV = this.passwordInput.value.length > 0;
        var confirmPasswordV = this.confirmPassword.value.length > 0;
        var passwordMatch = this.passwordInput.value === this.confirmPassword.value;
        if (driverNameV && emailV && passwordV && confirmPasswordV && passwordMatch) {
            this.setState({
                validateEmailMessage: null,
                validatePasswordMessage: null,
                validateConfirmPasswordMessage: null,
            });
            return true;
        } else {
            var driverNameMessage = driverNameV === true ? null : strings.formatString(strings.signup_error_required);
            var emailMessage = emailV === true ? null : strings.formatString(strings.signup_error_required);
            var passwordMessage = passwordV === true ? null : strings.formatString(strings.signup_error_required);
            var confirmPasswordMessage = confirmPasswordV === true ? null : strings.formatString(strings.signup_error_required);
            var passwordMatchMessage = passwordMatch === true ? null : strings.formatString(strings.password_error_match);

            this.setState({
                validateDriverNameMessage: driverNameMessage,
                validateEmailMessage: emailMessage,
                validatePasswordMessage: passwordMessage ? passwordMessage : passwordMatchMessage,
                validateConfirmPasswordMessage: confirmPasswordMessage ? confirmPasswordMessage : passwordMatchMessage,
            });
            return false;
        }
    }

    render() {

        var driverNameMessage = this.state.validateDriverNameMessage ?
            <p className="error-message">{this.state.validateDriverNameMessage}</p> :
            <p className="error-message">&nbsp;</p>;

        var emailMessage = this.state.validateEmailMessage ?
            <p className="error-message">{this.state.validateEmailMessage}</p> :
            <p className="error-message">&nbsp;</p>;
        var passwordMessage = this.state.validatePasswordMessage ?
            <p className="error-message">{this.state.validatePasswordMessage}</p> :
            <p className="error-message">&nbsp;</p>;
        var confirmPasswordMessage = this.state.validateConfirmPasswordMessage ?
            <p className="error-message">{this.state.validateConfirmPasswordMessage}</p> :
            <p className="error-message">&nbsp;</p>;
        return (
            <div id="createAccountPage" className="container create-account-page">
                <div className="container-fluid">
                    <div className="row">

                        <div className="col-12 col-md-6 main-group">
                            <form className="row" onSubmit={this.onSubmit}>

                                <div className="col-12">
                                    <h1>{strings.formatString(strings.title_activity_sign_up)}</h1>
                                    <p>{strings.formatString(strings.sign_up_message)}</p>
                                </div>

                                <div className="col-12">
                                    <label htmlFor="driverName">{strings.formatString(strings.profile_driver_name)}</label>
                                    <input id="driverName" ref={(driverNameInput) => { this.driverNameInput = driverNameInput }} type="text" placeholder="eg. Jane Doe" />
                                    {driverNameMessage}
                                </div>

                                <div className="col-12"></div>

                                <div className="col-12">
                                    <label htmlFor="email">{strings.formatString(strings.email_address_text)}</label>
                                    <input 
                                        id="email" 
                                        type="email" 
                                        placeholder="eg. jane@doe.com" 
                                        ref={(emailInput) => { this.emailInput = emailInput }}
                                    />
                                    {emailMessage}
                                </div>

                                <div className="col-12"></div>

                                <div className="col-12 col-lg-6">
                                    <label htmlFor="passwordInput">{strings.formatString(strings.sign_in_password)}</label>
                                    <input id="passwordInput" ref={(passwordInput) => { this.passwordInput = passwordInput }} onChange={this.onPasswordChange} type="password" placeholder="******" />
                                    {passwordMessage}
                                </div>

                                <div className="col-12 col-lg-6">
                                    <label htmlFor="confirmPassword">{strings.formatString(strings.sign_in_password_confirm)}</label>
                                    <input id="confirmPassword" ref={(confirmPassword) => { this.confirmPassword = confirmPassword }} type="password" placeholder="******" />
                                    {confirmPasswordMessage}
                                </div>

                                <div className="col-12 action-btns text-right">
                                    <button disabled={!this.state.isPasswordValid} className="btn"><i className="material-icons">check</i>{strings.formatString(strings.btn_send_create_account)}</button>
                                </div>

                                <div className="col-12">
                                    <p className="red">{this.state.errorMessage}</p>
                                </div>

                                <div className="col-12">
                                    <PasswordPolicyChecklist password={this.state.password} onPolicyCheck={(result) => { if(result !== this.state.isPasswordValid) this.setState({isPasswordValid: result})}} />
                                </div>
                            </form>
                        </div>
                        <div className="col-12 col-md-6 image-group"></div>
                    </div>
                </div>
            </div>
        );
    }
}
